<div class="row">
    <div class="col-12">
        <div class="d-flex align-items-center form-control p-0" style="border-width: 0px;">
            <ng-select style="flex-grow: 1; " (change)="selectClient(selectedModelsArray[0]?.id || undefined )"
                [multiple]="true" [maxSelectedItems]="1" bindLabel="name" placeholder={{searchPlaceHolderText}}
                [clearSearchOnAdd]="true" [items]="listItems$ | async"
                [isOpen]="(searchTermLength > minLengthTerm)  && !(selectedModelsArray[0]?.id)"
                [minTermLength]="minLengthTerm" [loading]="listItemsLoading"
                typeToSearchText="Please enter {{minLengthTerm}} or more characters" [typeahead]="listItemsInput$"
                [(ngModel)]="selectedModelsArray" [disabled]=disabled (clear)="arrayCleared()">

                <ng-template ng-option-tmp let-item="item">
                    {{item.name}} {{item.lastName}}
                </ng-template>
                <ng-template class=ng-value ng-label-tmp let-item="item">
                    <span class="ng-value-label" [ngClass]="{'ng-value-label': disabled}" style="cursor: pointer;"
                        [ngStyle]="{'cursor: default' : disabled}" (mousedown)="$event.stopPropagation()"
                        (click)="openModalEdit(item.id || 'Not Defined',$event ); ">
                        <b>{{item.name}} {{item.lastName}}</b>
                    </span>
                </ng-template>
            </ng-select>
            <button [disabled]="disabled" class="input-group-text"
                [ngStyle]="{'cursor': (disabled) ? 'default': 'pointer'} "
                style="   border-width:0; background-color: transparent;" (click)="openModalNewClientDropDownSearch()">
                <i class=" bx bx-user-plus " style=" font-size:20px ; "></i>
            </button>
            <div style="border-right: 1px solid var(--vz-input-border); height: 1.7rem;"></div>
            <button [disabled]=disabled class="input-group-text"
                style=" border-width:0; cursor:default ; background-color: transparent;">
                <i class=" bx bx-search " [ngStyle]="{'cursor': (disabled) ? 'default': 'pointer'} "
                    style=" font-size:18px; " (click)="openPicklistModal(referenceModel)"></i>
            </button>
        </div>
    </div>
</div>